<div class="view-broadcasted-job-page">

  <div class="section-title" *ngIf="hiredStaffers.length">Hired Employees:</div>

  <div class="applicants-grid" *ngIf="hiredStaffers.length">
    <ng-container *ngFor="let contractor of hiredStaffers | slice:contractorListStartIndex:contractorListEndIndex ; let i = index trackByIndex"> 
      <div class="applicant-card-wrapper"> 
        <div class="modern-contractor-card"> 
          <app-shift-detail-container [jobItem]="jobItem" [staffer]="contractor" [userData]="userData" [viewingHired]="true"></app-shift-detail-container> 
          <div class="action-footer" *ngIf="previousShiftView">
            <button class="btn-hire disabled">
              <span class="label">{{contractor.state}}</span>
            </button>
          </div>
        </div>
      </div> 
    </ng-container>
  </div>
  <app-pagination *ngIf="hiredStaffers && hiredStaffers.length" [totalRecords]="hiredStaffers.length" (onPageChange)="loadHiredStaffers($event)"></app-pagination>
  

  <div class="section-title" *ngIf="pendingConfirmationStaffers.length">Pending Confirmation:</div>

  <div class="applicants-grid" *ngIf="pendingConfirmationStaffers.length">
    <ng-container *ngFor="let contractor of pendingConfirmationStaffers | slice:pendingContractorListStartIndex:pendingContractorListEndIndex; let i = index trackByIndex"> 
      <div class="applicant-card-wrapper"> 
        <div class="modern-contractor-card"> 
          <app-shift-detail-container [jobItem]="jobItem" [staffer]="contractor" [userData]="userData"></app-shift-detail-container> 
        </div>
      </div> 
    </ng-container>
  </div>
  <app-pagination *ngIf="pendingConfirmationStaffers && pendingConfirmationStaffers.length" [totalRecords]="pendingConfirmationStaffers.length" (onPageChange)="loadPendingConfirmationStaffers($event)"></app-pagination>
 


  <div *ngIf="interestedStaffers.length && !jobItem.isFilled" class="section-title no-top-margin">Employees who applied:</div>

  <div class="applicants-grid">
    <ng-container *ngFor="let applicant of interestedStaffers | slice:applicantListStartIndex:applicantListEndIndex; let i = index trackByIndex">
      <div class="applicant-card-wrapper" *ngIf="!jobItem.isFilled">
        <div class="modern-contractor-card">
          <app-shift-detail-container [staffer]="applicant" [userData]="userData" (hireContractor)="hire(applicant.staffer, applicant.status)"></app-shift-detail-container>
          
          <div class="action-footer" *ngIf="applicant.status == 'interested' && !previousShiftView">
            <button (click)="reject(applicant.staffer, applicant.status)" class="btn-reject">
              <i class="fas fa-times-circle"></i>
              <span>Reject</span>
            </button>
            <button (click)="hire(applicant.staffer, applicant.status)" class="btn-hire">
              <span>Hire Employee</span>
              <div class="icon-circle"><i class="fas fa-arrow-right"></i></div>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <app-pagination *ngIf="interestedStaffers && interestedStaffers.length && !jobItem.isFilled" [totalRecords]="interestedStaffers.length" (onPageChange)="loadInterestedStaffers($event)"></app-pagination>
</div>
